import isArrayNotEmpty from './isarraynotempty';

const removeEmptyDataFromObject = (obj: any) => {
  const result = { ...obj };

  for (let item in result) {
    if (
      (typeof result[item] === 'string' && !result[item]) ||
      (typeof result[item] !== 'string' && !isArrayNotEmpty(result[item]))
    ) {
      delete result[item];
    }
  }

  return result;
};

export default removeEmptyDataFromObject;



// WEBPACK FOOTER //
// ./src/tools/removeEmptyDataFromObject.ts